module.exports = __webpack_public_path__ + "static/media/manage_documents.a379a42d.svg";